import React from 'react';
import useCookie from 'hooks/useCookie';
import { useTranslation } from 'react-i18next';
import { navList, langList } from 'language/navLang';
import { NavLink } from 'react-router-dom';
import whiteLogo from 'assets/icons/logo_white.svg';
import { Img } from 'components';
import { Text } from 'styles';
import { logos, selectLang } from 'lang';
import * as S from './FooterStyle';

export function Footer({ list, navList, selectedLang }) {
  const { setCookies } = useCookie();

  const { t, i18n } = useTranslation();
  return (
    list && (
      <S.Container>
        <S.Wrap>
          <S.LogoBox>
            <Img
              src={whiteLogo}
              $width={140}
              $height={46}
              $tHeight={38}
              $mWdith={110}
              $mHeight={30}
              alt="로고"
              $objectFit="cover"
            />
            <S.SnsBox>
              {logos.map((logo, index) => (
                <div key={`logo_${index}`} onClick={() => window.open(logo.link)} role="presentation">
                  <Img src={logo.img} $width={36} $height={36} $pointer />
                </div>
              ))}
            </S.SnsBox>
          </S.LogoBox>
          <S.InfoContainer>
            <S.InfoBox>
              <Text $type="h6" $color="secondary100">
                {t('company_name')}
              </Text>
              <S.Address>{t('company_address')}</S.Address>
              <S.InfoDiv>
                <Text $type="h8">TEL</Text>
                <Text $type="b8" $fontWeight={400}>
                  {t('company_tel')}
                </Text>
              </S.InfoDiv>
              <S.InfoDiv>
                <Text $type="h8">FAX</Text>
                <Text $type="b8" $fontWeight={400}>
                  {t('company_fax')}
                </Text>
              </S.InfoDiv>
              <S.InfoDiv>
                <Text $type="h8">E-MAIL</Text>
                <Text $type="b8" $fontWeight={400}>
                  {t('company_email')}
                </Text>
              </S.InfoDiv>
            </S.InfoBox>
            <S.List>
              {navList.map((item, index) => (
                <S.ListItem key={`item_${index}`}>
                  <S.ListTitle>
                    <Text $type="h7" $color="secondary100">
                      {t(item.name)}
                    </Text>
                  </S.ListTitle>
                  <S.SubList>
                    {item.sub.map((sub, idx) => (
                      <S.SubListItem key={`sub_${idx}`}>
                        <NavLink to={sub.path}>
                          <Text $type="b8" $fontWeight={400} $color="white">
                            {t(sub.name)}
                          </Text>
                        </NavLink>
                      </S.SubListItem>
                    ))}
                  </S.SubList>
                </S.ListItem>
              ))}
              {/*
              언어 변경 선택
              <S.ListItem>
                <S.LangList>
                  {langList.map((lang, index) => (
                    <li key={`lang_${index}`} onClick={() => i18n.changeLanguage(lang.value)}>
                      <Text
                        type="h7"
                        $color={(i18n.language === lang.value && 'white') || 'rgba(255, 255, 255, 0.15)'}
                      >
                        {t(`language_${lang.value}`)}
                      </Text>
                    </li>
                  ))}
                </S.LangList>
              </S.ListItem> */}
            </S.List>
          </S.InfoContainer>
          <Text $fontSize={11} $weight={500} $textAlign="center" $color="rgba(255, 255, 255, 0.33)">
            Copyright 2023 FARMIN. All Rights Reserved.
          </Text>
        </S.Wrap>
      </S.Container>
    )
  );
}
